import React from 'react';

import { dateOnlySlashesFormat, formatUtcDate } from 'App/services/DateService';
import { branchSettingsPropType, patientPropType } from 'Shared/types';
import PropTypes from 'prop-types';
import EhrEncounterReviewContent from 'App/components/EHR/EhrEncounterReviewContent';
import { ReviewSectionStyle } from 'App/components/EHR/styles';

const BenefitsInvestigationEncounterReviewContent = ({
    patient,
    branchSettings,
    medicationList,
    benefitsInvestigationReferralDetails,
}) => {
    return (
        <div>
            <EhrEncounterReviewContent
                patient={patient}
                branchSettings={branchSettings}
                medicationList={medicationList}
            />

            <ReviewSectionStyle>
                <strong>Referral Details (Benefits Investigation)</strong>
                <div>Status: {benefitsInvestigationReferralDetails?.status || '--'}</div>
                <div>
                    Start Date:{' '}
                    {formatUtcDate({
                        date: benefitsInvestigationReferralDetails?.startDate?.toString(),
                        format: dateOnlySlashesFormat,
                    }) || '--'}
                </div>

                <div>
                    Due Date:{' '}
                    {formatUtcDate({
                        date: benefitsInvestigationReferralDetails?.endDate?.toString(),
                        format: dateOnlySlashesFormat,
                    }) || '--'}
                </div>

                <div>
                    Complete Date:{' '}
                    {formatUtcDate({
                        date: benefitsInvestigationReferralDetails?.completeDate?.toString(),
                        format: dateOnlySlashesFormat,
                    }) || '--'}
                </div>

                <div>
                    Patient Total Responsibility:{' '}
                    {benefitsInvestigationReferralDetails?.patientTotalResponsibility || '--'}
                </div>
                <div>Copay Amount: {medicationList[0]?.data?.copayAmount || '--'}</div>
                <div>CoInsurance Amount: {medicationList[0]?.data?.copayPercent || '--'}</div>

                <div>Status Reason: {benefitsInvestigationReferralDetails?.statusReason?.valueName || '--'}</div>

                <div>
                    Initial Medication Site Care:{' '}
                    {benefitsInvestigationReferralDetails?.initialMedicationSite?.valueName || '--'}
                </div>
            </ReviewSectionStyle>

            <ReviewSectionStyle>
                <strong>Notes</strong>
                <div>{benefitsInvestigationReferralDetails?.activityNotes || '--'}</div>
            </ReviewSectionStyle>
        </div>
    );
};

BenefitsInvestigationEncounterReviewContent.propTypes = {
    patient: patientPropType.isRequired,
    branchSettings: branchSettingsPropType.isRequired,
    medicationList: PropTypes.arrayOf(
        PropTypes.shape({
            data: PropTypes.shape({
                copayAmount: PropTypes.string,
                copayPercent: PropTypes.number,
            }),
            medication: PropTypes.shape({
                id: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            }),
        })
    ).isRequired,
    benefitsInvestigationReferralDetails: PropTypes.shape({
        status: PropTypes.string.isRequired,
        startDate: PropTypes.instanceOf(Date),
        endDate: PropTypes.instanceOf(Date),
        completeDate: PropTypes.instanceOf(Date),
        patientTotalResponsibility: PropTypes.number,
        statusReason: PropTypes.shape({
            id: PropTypes.string,
            valueName: PropTypes.string,
        }),
        initialMedicationSite: PropTypes.shape({
            id: PropTypes.string,
            valueName: PropTypes.string,
        }),
        activityNotes: PropTypes.string,
    }).isRequired,
};

export default BenefitsInvestigationEncounterReviewContent;
